module.exports = __webpack_public_path__ + "static/media/mc.42a371b2.png";